import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { playExperiment } from '../actions';
import { getSelectedVariants, getUserIdentifier } from '../selectors';
import { Props as VariantProps } from './Variant';

interface Props {
  name: string;
  children?: React.ReactNode;
}

const Experiment: React.FC<Props> = React.memo(({ name, children }) => {
  const experiments = useSelector(getSelectedVariants);
  const variant = experiments[name];

  const userIdentifier = useSelector(getUserIdentifier);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(playExperiment(name, variant, userIdentifier));
  }, []);

  const variants = {};

  React.Children.forEach(children, element => {
    if (React.isValidElement(element)) {
      variants[(element.props as VariantProps).name] = element;
    }
  });

  return variants[variant] || null;
});

export default Experiment;
